module.exports = __webpack_public_path__ + "static/img/user.9dc4c5eb.png";